import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  DialogTitle,
  TableRow,
  TableCell,
  TableHead,
  Table,
  TableContainer,
  Grid,
  TableBody,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { connect, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { START_GLOBAL_SETTING_ACCESS } from "Actions/RepeatOrderAction";
import TableEmptyState from "Components/Common/Table/TableEmptyState";
import clsx from "clsx";
import { START_CREATE_SURGERY_MULTI } from "Actions/SurgeryAction";
import { PrimaryDialogTitle } from "Components/Common/Dialog/DialogComponents";
import useViewport from "Hooks/useViewport";
import { Height } from "@mui/icons-material";
const useStyle = makeStyles((theme) => ({
  rsAlignMain: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  rsDialogContent: {
    paddingTop: "0px !important",
  },
  rsDialogMainRoot: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      [theme.breakpoints.down("1102")]: {
        maxWidth: "75% !important",
        marginTop: "-20px !important",
      },
      [theme.breakpoints.down("768")]: {
        maxWidth: "95% !important",
      },
    },
  },
}));

const ImportTypeDialog = (props) => {
  const { open, setOpen, link } = props;
  const classes = useStyle();
  const loginUserDetail = useSelector((state) => state.user);
  const handleClose = () => {
    setOpen(false);
  };
  let { height, width } = useViewport();
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={clsx("rsDialogMain", classes.rsDialogMainRoot)}
      >
        <PrimaryDialogTitle handleClose={handleClose} />
        <DialogContent className={classes.rsDialogContent}>
          <Box className={classes.rsAlignMain}>
            <iframe
              src={link}
              width="100%"
              title="Document"
              height={height < 750 ? "450" : "663"}
            />
          </Box>
        </DialogContent>

        {/* <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  globalSettingAccess: state.order.globalSettingAccess,
  createSurgeryMultiData: state.surgery.createSurgeryMultiData,
});
const mapDispatchToProps = (dispatch) => ({
  getGlobalSettingAccessAction: () =>
    dispatch({ type: START_GLOBAL_SETTING_ACCESS }),
  createSurgeryMultipleAction: (payload) =>
    dispatch({ type: START_CREATE_SURGERY_MULTI, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportTypeDialog);
